<template>
  <section class="">
    <base-tabs :data="tabs" @change="changeTab"></base-tabs>
    <div class="wrapper">
      <div class="course-list">
        <ul class="sort-key-tabs">
          <li
            class="sort-key-tab"
            v-for="(item, index) in sortKeyList"
            :key="index"
            :class="{
              'sort-key-tab--active': activeSortKey === index,
              ascending:
                activeSortKey === index &&
                item.direction === SortDirection.ascending,
              descending:
                activeSortKey === index &&
                item.direction === SortDirection.descending
            }"
            @click="changeSortKey(item, index)"
          >
            <span class="sort-key-name"
              >{{ item.name }}
              <span class="caret-wrapper">
                <span class="sort-caret ascending"></span>
                <span class="sort-caret descending"></span> </span
            ></span>
          </li>
        </ul>
        <course-list
          :list="courseList"
          :end="pageEnd"
          :show-button="true"
          @loadMore="getCourseList"
        ></course-list>
      </div>
      <div class="hot-lecturer-panel">
        <star-author-panel :type="2" title="热门讲师"></star-author-panel>
      </div>
    </div>
  </section>
</template>

<script>
import { getCourseList } from '@/api/course'
import CourseList from '@/components/CourseList/CourseList'
import BaseTabs from '@/components/BaseTabs/BaseTabs'
import StarAuthorPanel from '@/components/StarAuthorPanel/StarAuthorPanel'

/**
 * 排序方向
 * @type {{ascending: number, descending: number}}
 */
const SortDirection = {
  /**
   * 无效
   */
  none: 0,
  /**
   * 升序
   */
  ascending: 1,
  /**
   * 降序
   */
  descending: 2
}

export default {
  name: 'Course',
  components: { StarAuthorPanel, BaseTabs, CourseList },
  data() {
    return {
      SortDirection,
      tabs: [
        { name: '全部', type: 6 },
        { name: '月课', type: 1 },
        { name: '年课', type: 2 },
        { name: '专辑', type: 3 }
      ],
      activeTab: 0,
      sortKeyList: [
        {
          name: '更新时间',
          type: 0,
          direction: SortDirection.descending
        },
        {
          name: '销量',
          type: 1,
          direction: SortDirection.none
        },
        {
          name: '价格',
          type: 2,
          direction: SortDirection.none
        }
      ],
      activeSortKey: 0,
      courseList: [],
      viewState: '',
      pageEnd: true
    }
  },
  created() {
    this.getCourseList()
  },
  methods: {
    changeTab(index) {
      this.activeTab = index
      this.viewState = ''

      this.getCourseList()
    },
    changeSortKey(item, index) {
      this.sortKeyList.splice(index, 1, {
        ...item,
        direction:
          item.direction === SortDirection.none ||
          item.direction === SortDirection.descending
            ? SortDirection.ascending
            : SortDirection.descending
      })
      this.activeSortKey = index
      this.viewState = ''
      this.getCourseList()
    },
    async getCourseList() {
      const sortKey = this.sortKeyList[this.activeSortKey]

      const data = await getCourseList(
        {
          type: this.tabs[this.activeTab].type,
          sortKey: sortKey.type,
          orderBy: sortKey.direction,
          direction: this.viewState ? 2 : 0
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end

          if (data.detail.flush) {
            this.courseList = data.detail.list
          } else {
            this.courseList = this.courseList.concat(data.detail.list)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-key-tabs {
  font-size: 12px;
  line-height: 52px;
  letter-spacing: 1px;
  color: #262626;
  margin-top: 30px;
  display: flex;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;

  .sort-key-tab {
    cursor: pointer;
  }

  .sort-key-name {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
  }
}

.caret-wrapper {
  display: inline-flex;
  height: 34px;
  width: 24px;
  overflow: initial;
  position: relative;

  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;

    &.ascending {
      border-bottom-color: #c0c4cc;
      top: 5px;
    }

    &.descending {
      border-top-color: #c0c4cc;
      bottom: 7px;
    }

    .ascending &.ascending {
      border-bottom-color: #409eff;
    }

    .descending &.descending {
      border-top-color: #409eff;
    }
  }
}

.course-list {
  flex: auto;
}

.wrapper {
  display: flex;
  align-items: flex-start;
}

.hot-lecturer-panel {
  margin-top: 30px;
  padding-left: 30px;
}
</style>
